<app-header header="home.title" subHeader="home.subtitle"></app-header>

@if (isAtruvia) {
  <div class="is-flex is-justify-content-center my-5 py-5">
    <button
      type="button"
      fino-button
      label="home.manual-button"
      icon="Video Player"
      (click)="openManual()"
    ></button>
  </div>
}

<div class="grid is-gap-3 py-5 mt-5">
  <div class="cell">
    <app-action-box
      header="home.actions.overview.title"
      subHeader="home.actions.overview.subtitle"
      class="is-fullheight is-flex"
      iconSrc="/assets/icons/icon-info.svg"
      iconClass="p-4"
      (action)="open(Routes.Overview)"
    >
      <hr class="is-fullwidth" />

      <app-action-links
        [links]="overviewLinks"
        [productLink]="Routes.Overview"
      ></app-action-links>
    </app-action-box>
  </div>
  <div class="cell">
    <app-action-box
      class="is-flex is-fullheight"
      [header]="kwhTitle"
      [subHeader]="kwhDescription"
      iconSrc="/assets/icons/icon-kontowechselhilfe.svg"
      iconClass="p-4"
      [hideCtaButton]="!canActivateKwh"
      [isNotClickable]="!canActivateKwh"
      (action)="open(Routes.KWH)"
      [active]="isKwhActive"
    >
      @if (canActivateKwh) {
        <hr class="is-fullwidth" />

        <app-action-links
          [links]="kwhLinks"
          [productLink]="Routes.KWH"
        ></app-action-links>
      }
    </app-action-box>
  </div>

  <div class="cell">
    <app-action-box
      class="is-flex is-fullheight"
      [header]="kwsTitle"
      [subHeader]="kwsDescription"
      iconSrc="/assets/icons/icon-kontowechselservice.svg"
      iconClass="p-4"
      (action)="open(Routes.KWS)"
      [hideCtaButton]="!canActivateKws"
      [isNotClickable]="!canActivateKws"
      [active]="isKwsActive"
    >
      @if (canActivateKws) {
        <hr class="is-fullwidth" />

        <app-action-links
          [links]="kwsLinks"
          [productLink]="Routes.KWS"
        ></app-action-links>
      }
    </app-action-box>
  </div>

  @if (!isAtruvia) {
    <div class="cell">
      <app-action-box
        class="is-flex is-fullheight"
        [header]="dwsTitle"
        [subHeader]="dwsDescription"
        icon="Saving Bull Market Increase"
        iconClass="p-4"
        [iconStyles]="{ position: 'relative', right: '2px' }"
        (action)="open(Routes.DWS)"
        [hideCtaButton]="!isDwsActive"
        [isNotClickable]="!isDwsActive"
        [active]="isDwsActive"
      ></app-action-box>
    </div>
  }

  @if (hasBestandskundenCockpit) {
    <div class="cell">
      <app-action-box
        class="is-flex is-fullheight"
        header="home.actions.cockpit.title"
        subHeader="home.actions.cockpit.subtitle"
        icon="Monitor Chart"
        active="true"
        iconClass="p-4"
        ctaLabel="home.actions.cockpit.cta"
        (action)="openBestandskundenCockpit()"
      ></app-action-box>
    </div>
  }

  <div class="cell">
    <app-action-box
      class="is-flex is-fullheight"
      header="home.actions.sustainability.title"
      subHeader="home.actions.sustainability.subtitle"
      ctaLabel="home.actions.sustainability.label"
      icon="Renewable Energy Earth"
      iconClass="p-4"
      (action)="open(Routes.Sustainability)"
    ></app-action-box>
  </div>
</div>
